import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const resourceLinks = [
  {
    label: "Guide complet Hipobuy Spreadsheet 2026",
    href: "/article/guide-complet",
  },
];

const aboutLinks = [
  { label: "Hipobuy Spreadsheet", href: "https://kaspreadsheet.com/", external: true },
  { label: "Blog SEO", href: "/article/guide-complet", external: false },
];

const contactLinks = [
  { label: "kaspreadsheet.com", href: "https://kaspreadsheet.com/", external: true },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="px-6 md:px-12 py-20 md:py-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-16">
          {/* Catégories */}
          <div>
            <h4 className="text-sm font-semibold tracking-wider mb-6 text-background-50/90">
              Catégories
            </h4>
            <div className="w-8 h-px bg-background-50/30 mb-5"></div>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Ressources */}
          <div>
            <h4 className="text-sm font-semibold tracking-wider mb-6 text-background-50/90">
              Ressources
            </h4>
            <div className="w-8 h-px bg-background-50/30 mb-5"></div>
            <ul className="space-y-2.5">
              {resourceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* À propos */}
          <div>
            <h4 className="text-sm font-semibold tracking-wider mb-6 text-background-50/90">
              À propos
            </h4>
            <div className="w-8 h-px bg-background-50/30 mb-5"></div>
            <ul className="space-y-2.5">
              {aboutLinks.map((link) =>
                link.external ? (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ) : (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold tracking-wider mb-6 text-background-50/90">
              Contact
            </h4>
            <div className="w-8 h-px bg-background-50/30 mb-5"></div>
            <ul className="space-y-2.5">
              {contactLinks.map((link) =>
                link.external ? (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ) : (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-20 md:mt-24 pt-8 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <p className="text-4xl md:text-5xl font-bold tracking-tight text-background-50 font-heading">
              Hipobuy
            </p>
            <p className="text-2xl md:text-3xl font-light tracking-wide text-background-50/80 font-heading mt-0.5">
              Spreadsheet
            </p>
            <div className="w-12 h-px bg-background-50/30 mt-3 mb-2"></div>
            <p className="text-xs text-background-50/50 font-sans">
              La solution intelligente pour votre budget
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-8">
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener nofollow"
                aria-label="Instagram"
                className="w-8 h-8 flex items-center justify-center text-background-50/60 hover:text-background-50 transition-colors"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.pinterest.com/"
                target="_blank"
                rel="noopener nofollow"
                aria-label="Pinterest"
                className="w-8 h-8 flex items-center justify-center text-background-50/60 hover:text-background-50 transition-colors"
              >
                <i className="ri-pinterest-line text-lg"></i>
              </a>
              <a
                href="https://x.com/"
                target="_blank"
                rel="noopener nofollow"
                aria-label="X"
                className="w-8 h-8 flex items-center justify-center text-background-50/60 hover:text-background-50 transition-colors"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
            </div>
            <p className="text-xs text-background-50/40 font-sans">
              © 2026 hipobuyspreadsheets.site
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}